import "./EditCommunicationConfiguration.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditCommunicationConfigurationComponentController from "./EditCommunicationConfigurationComponentController";

export default class EditCommunicationConfigurationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditCommunicationConfigurationComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/" +
            "SelectedEquipment/EquipmentDetails/EditCommunicationConfiguration/EditCommunicationConfiguration.html";
    }
}

module("mmManagePortal").component("irEditCommunicationConfiguration", new EditCommunicationConfigurationComponent());
